import { fromEvent } from 'rxjs';
import { TopControlSize } from '../../../services/wb-top-controls-v2.service';

export const TOP_CONTROLS_V2_DEFAULT_HEIGHT_PX = 48;
export const MD_SECTION_TITLE_TRUNCATE_DEFAULT_LENGTH = 32;
export const MD_SECTION_TITLE_TRUNCATE_SMALL_LENGTH = 30;

export const TOP_CONTROLS_V2_MENU_BACKDROP_CLASS = 'top-controls-v2-backdrop-class';
export const topControlsV2BackDropEvent$ = (eventName: string) =>
  fromEvent(document.getElementsByClassName(TOP_CONTROLS_V2_MENU_BACKDROP_CLASS), eventName);

export const LeaderBoundaryBottomValues = {
  DEFAULT: 0,
  XSMALL_UI_NON_CALL: 82,
  XSMALL_UI_ON_CALL_CONTROL_TOP: 172,
  XSMALL_UI_ON_CALL_CONTROL_MINIMIZED: 102,
};
export const INDICATORS_CONTAINER_DEFAULT_PADDING_LEFT_PX = 12;
export const INDICATORS_CONTAINER_DEFAULT_PADDING_TOP_PX = 12;
export const INDICATORS_CONTAINER_MOBILE_PADDING_TOP_PX = 8;
export const CONTAINER_DEFAULT_POSITION_TOP_PX = 48;
export const CONTAINER_VIDEO_LAYOUT_MINIMIZED_POSITION_TOP_PX = 153;
export const CONTAINER_VIDEO_LAYOUT_TOP_POSITION_TOP_PX = 224;

export const USERS_PRESENCE_LIST_DEFAULT_LIMIT = 2;
export const USERS_PRESENCE_LIST_USER_IN_CALL_LIMIT = 1;
export const USERS_PRESENCE_LIST_OBSERVERS_LIMIT = 1;

export const TOOL_WIDTH_PX = 38;
export const TOOL_DIVIDER_WIDTH = 1;
export const TOOL_GAP = 8;
export const LEFT_SECTION_ALWAYS_VISIBLE_ELEMENTS =
  TOOL_WIDTH_PX + TOOL_GAP * 2 + TOOL_DIVIDER_WIDTH;

export const calculateLeaderBoundaryPosition = (
  topBarHidden = false,
): { top: number; height: number } => {
  const bottom = LeaderBoundaryBottomValues.DEFAULT;
  const top = 0;
  const height = top + bottom + (topBarHidden ? 0 : TOP_CONTROLS_V2_DEFAULT_HEIGHT_PX);

  return {
    top,
    height,
  };
};

/**
 * Determines if the Sparky tool button should be shown in the top controls.
 * The button is visible when:
 * - The device is not mobile AND
 * - Either:
 *   - The top control size is XLarge/Large OR
 *   - The system status button is hidden
 */
export const canRenderSparkyToolOnTopControls = (
  isMobileDevice: boolean,
  topControlSize: TopControlSize,
  statusToolButtonVisible: boolean,
) =>
  topControlSize !== TopControlSize.Small &&
  !isMobileDevice &&
  (!statusToolButtonVisible ||
    [TopControlSize.XLarge, TopControlSize.Large].includes(topControlSize));
export const canRenderCopyLinkAndInviteToolsAsGroup = (topControlSize: TopControlSize) =>
  [TopControlSize.XLarge].includes(topControlSize);

export const canRenderParticipantsToolOnTopControls = (
  topControlSize: TopControlSize,
  isStandAloneModeEnabled: boolean,
) => topControlSize !== TopControlSize.Small || isStandAloneModeEnabled;
